import React, { useEffect, useState } from "react"
import { MdCancel, MdSave } from "react-icons/md"
import { useNavigate } from "react-router-dom"
import {
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Card,
  CardBody,
  FormFeedback,
} from "reactstrap"
import { fetchData } from "utils/Common_api_functions"
import INDIAN_STATES from "utils/States"

const LeadForm = ({
  formData,
  setFormData,
  onSubmit,
  users = [],
  leadSources,
  mode = "edit", // "edit" | "view"
}) => {
  const navigate = useNavigate()
  const [errors, setErrors] = useState({})
  const isView = mode === "view"

  const [categroy, setCategory] = useState([])

  useEffect(() => {
    getEquipmentCategory()
  }, [])

  async function getEquipmentCategory() {
    const APIData = await fetchData(() => {}, "equipment/category")
    if (APIData?.success) {
      setCategory(APIData?.data)
    }
  }

  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const validate = () => {
    let newErrors = {}

    // ================= Lead Info =================
    if (!formData.leadSourceId) newErrors.leadSourceId = "Source required"

    if (!formData.assignedTo) newErrors.assignedTo = "Staff required"

    if (!formData.status) newErrors.status = "Status required"

    if (!formData.leadType) newErrors.leadType = "Lead type required"

    // ================= Company & Contact =================
    if (!formData.contactPersonName?.trim())
      newErrors.contactPersonName = "Contact person required"

    if (!formData.contactPersonPhone)
      newErrors.contactPersonPhone = "Phone required"
    else if (!/^[0-9]{10}$/.test(formData.contactPersonPhone))
      newErrors.contactPersonPhone = "Invalid 10 digit phone"

    // ================= Address =================

    if (!formData.address?.trim()) newErrors.address = "Address required"

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = e => {
    e.preventDefault()
    if (validate()) onSubmit(e)
  }

  return (
    <Form onSubmit={handleSubmit}>
      {/* ================= Lead Information ================= */}
      <Card className="mb-4 shadow-sm rounded-4">
        <CardBody>
          <div className="d-flex justify-content-between mb-3">
            <h5 className="border-bottom pb-2">Lead Information</h5>

            <div className="d-flex gap-2">
              {" "}
              {!isView && (
                <Button className="btn-blue" type="submit">
                  <MdSave /> Save
                </Button>
              )}
              <Button color="secondary" onClick={() => navigate(-1)}>
                <MdCancel /> Cancel
              </Button>
            </div>
          </div>

          <Row>
            <Col md={3}>
              <FormGroup>
                <Label>
                  Source <span className="text-danger">*</span>
                </Label>
                <Input
                  type="select"
                  name="leadSourceId"
                  value={formData.leadSourceId || ""}
                  onChange={handleChange}
                  invalid={!!errors.leadSourceId}
                  disabled={isView}
                  className="form-select rounded-4"
                >
                  <option value="">Select Source</option>
                  {leadSources?.map(item => (
                    <option value={item?.id} key={item?.id}>
                      {item?.sourceName}
                    </option>
                  ))}
                </Input>

                <FormFeedback>{errors.leadSourceId}</FormFeedback>
              </FormGroup>
            </Col>

            {formData.source === "reference" && (
              <Col md={3}>
                <FormGroup>
                  <Label>
                    Reference Name <span className="text-danger">*</span>
                  </Label>
                  <Input
                    name="reference"
                    value={formData.reference || ""}
                    onChange={handleChange}
                    disabled={isView}
                    className="form-control rounded-4"
                  ></Input>
                </FormGroup>
              </Col>
            )}

            {formData.source === "other" && (
              <Col md={3}>
                <FormGroup>
                  <Label>
                    Other Source <span className="text-danger">*</span>
                  </Label>
                  <Input
                    name="otherSource"
                    value={formData.otherSource || ""}
                    onChange={handleChange}
                    disabled={isView}
                    className="form-control rounded-4"
                  ></Input>
                </FormGroup>
              </Col>
            )}

            <Col md={3}>
              <FormGroup>
                <Label>
                  Assigned to Staff <span className="text-danger">*</span>
                </Label>
                <Input
                  type="select"
                  name="assignedTo"
                  value={formData.assignedTo || ""}
                  onChange={handleChange}
                  invalid={!!errors.assignedTo}
                  disabled={isView || mode === "edit"}
                  className="form-select rounded-4"
                >
                  <option value="">Select Staff</option>
                  {users?.map(user => (
                    <option key={user._id} value={user.id}>
                      {user.name}
                    </option>
                  ))}
                </Input>
                <FormFeedback>{errors.assignedTo}</FormFeedback>
              </FormGroup>
            </Col>

            <Col md={3}>
              <FormGroup>
                <Label>
                  Status <span className="text-danger">*</span>
                </Label>
                <Input
                  type="select"
                  name="status"
                  value={formData.status || ""}
                  onChange={handleChange}
                  invalid={!!errors.status}
                  disabled={isView}
                  className="form-select rounded-4"
                >
                  <option value="">Select</option>
                  <option value="new">New</option>
                  <option value="introduction">Introduction</option>
                  <option value="meeting">Meeting</option>
                  <option value="document_collected">Document Collected</option>
                  <option value="file_login">File Login</option>
                  <option value="win">Win</option>
                  <option value="lost">Lost</option>
                </Input>
                <FormFeedback>{errors.status}</FormFeedback>
              </FormGroup>
            </Col>

            <Col md={3}>
              <FormGroup>
                <Label>
                  Lead Type <span className="text-danger">*</span>
                </Label>
                <Input
                  type="select"
                  name="leadType"
                  value={formData.leadType || ""}
                  onChange={handleChange}
                  invalid={!!errors.leadType}
                  disabled={isView}
                  className="form-select rounded-4"
                >
                  <option value="">Select</option>
                  <option value="hot_1_month">Hot (1 Month)</option>
                  <option value="warm_2_month">Warm (2 Month)</option>
                  <option value="cold_3_month">Cold (3 Month)</option>
                  <option value="normal_enquiry">Normal (Enquiry)</option>
                  <option value="extreme_hot_10_days">
                    Extreme Hot (10 days)
                  </option>
                </Input>
                <FormFeedback>{errors.leadType}</FormFeedback>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>

      {/* ================= Company & Contact ================= */}
      <Card className="mb-4 shadow-sm rounded-4">
        <CardBody>
          <h5 className="border-bottom pb-2 mb-3">Company & Contact Details</h5>

          <Row>
            <Col md={3}>
              <FormGroup>
                <Label>Company Name</Label>
                <Input
                  name="company"
                  value={formData.company || ""}
                  onChange={handleChange}
                  disabled={isView}
                  className="form-control rounded-4"
                />
              </FormGroup>
            </Col>

            <Col md={3}>
              <FormGroup>
                <Label>
                  Contact Person <span className="text-danger">*</span>
                </Label>
                <Input
                  name="contactPersonName"
                  value={formData.contactPersonName || ""}
                  onChange={handleChange}
                  invalid={!!errors.contactPersonName}
                  disabled={isView}
                  className="form-control rounded-4"
                />
                <FormFeedback>{errors.contactPersonName}</FormFeedback>
              </FormGroup>
            </Col>

            <Col md={3}>
              <FormGroup>
                <Label>Email</Label>
                <Input
                  name="contactPersonEmail"
                  value={formData.contactPersonEmail || ""}
                  onChange={handleChange}
                  disabled={isView}
                  className="form-control rounded-4"
                />
              </FormGroup>
            </Col>

            <Col md={3}>
              <FormGroup>
                <Label>
                  Phone <span className="text-danger">*</span>
                </Label>
                <Input
                  name="contactPersonPhone"
                  value={formData.contactPersonPhone || ""}
                  onChange={handleChange}
                  invalid={!!errors.contactPersonPhone}
                  disabled={isView}
                  className="form-control rounded-4"
                  maxLength={10}
                />
                <FormFeedback>{errors.contactPersonPhone}</FormFeedback>
              </FormGroup>
            </Col>

            <Col md={3}>
              <FormGroup>
                <Label>Alternate Contact Person </Label>
                <Input
                  name="alternatecontactPersonName"
                  value={formData.alternatecontactPersonName || ""}
                  onChange={handleChange}
                  disabled={isView}
                  className="form-control rounded-4"
                />
              </FormGroup>
            </Col>

            <Col md={3}>
              <FormGroup>
                <Label>Alternate Phone</Label>
                <Input
                  name="alternatecontactPersonPhone"
                  value={formData.alternatecontactPersonPhone || ""}
                  onChange={handleChange}
                  disabled={isView}
                  className="form-control rounded-4"
                  maxLength={10}
                />
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>

      {/* ================= Address ================= */}
      <Card className="mb-4 shadow-sm rounded-4">
        <CardBody>
          <h5 className="border-bottom pb-2 mb-3">Address Details</h5>

          <Row>
            <Col md={3}>
              <FormGroup>
                <Label>State</Label>
                <Input
                  type="select"
                  name="state"
                  disabled={isView}
                  value={formData.state || ""}
                  onChange={handleChange}
                  className="form-select rounded-4"
                >
                  <option value="">Select State</option>
                  {INDIAN_STATES.map(state => (
                    <option key={state.value} value={state.value}>
                      {state.label}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Col>

            <Col md={3}>
              <FormGroup>
                <Label>City</Label>
                <Input
                  name="city"
                  value={formData.city || ""}
                  onChange={handleChange}
                  invalid={!!errors.city}
                  disabled={isView}
                  className="form-control rounded-4"
                />
                <FormFeedback>{errors.city}</FormFeedback>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Label>Pincode</Label>
                <Input
                  name="pincode"
                  value={formData.pincode || ""}
                  onChange={handleChange}
                  disabled={isView}
                  className="form-control rounded-4"
                />
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label>
                  Address <span className="text-danger">*</span>
                </Label>
                <Input
                  name="address"
                  value={formData.address || ""}
                  onChange={handleChange}
                  disabled={isView}
                  className="form-control rounded-4"
                />
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label>Landmark</Label>
                <Input
                  name="landmark"
                  value={formData.landmark || ""}
                  onChange={handleChange}
                  invalid={!!errors.landmark}
                  disabled={isView}
                  className="form-control rounded-4"
                />
                <FormFeedback>{errors.landmark}</FormFeedback>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>

      {/* ================= Equipment Requirement ================= */}
      <Card className="mb-4 shadow-sm rounded-4">
        <CardBody>
          <h5 className="border-bottom pb-2 mb-3">Equipment Requirement</h5>

          <Row>
            <Col md={3}>
              <FormGroup>
                <Label>Equipment Category</Label>
                <Input
                  type="select"
                  name="equipmentCategoryId"
                  value={formData.equipmentCategoryId || ""}
                  onChange={handleChange}
                  disabled={isView}
                  className="form-select rounded-4"
                >
                  <option value="">Select</option>
                  {categroy?.map(item => (
                    <option value={item?.id} key={item?.id}>
                      {item?.name}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Col>

            <Col md={3}>
              <FormGroup>
                <Label>Model</Label>
                <Input
                  name="model"
                  value={formData.model || ""}
                  onChange={handleChange}
                  disabled={isView}
                  className="form-control rounded-4"
                />
              </FormGroup>
            </Col>

            <Col md={12}>
              <FormGroup>
                <Label>Discussion</Label>
                <textarea
                  name="discussion"
                  value={formData.discussion || ""}
                  onChange={handleChange}
                  disabled={isView}
                  className="form-control rounded-4"
                  rows={4}
                />
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>

      {/* ================= Commercial / Finance ================= */}
      <Card className="mb-4 shadow-sm rounded-4">
        <CardBody>
          <h5 className="border-bottom pb-2 mb-3">
            Commercial / Finance Details
          </h5>

          <Row>
            <Col md={3}>
              <FormGroup>
                <Label>Price Given to Customer</Label>
                <Input
                  name="priceGiven"
                  value={formData.priceGiven || ""}
                  onChange={handleChange}
                  disabled={isView}
                  className="form-control rounded-4"
                ></Input>
              </FormGroup>
            </Col>

            <Col md={3}>
              <FormGroup>
                <Label>Down Payment Amount</Label>
                <Input
                  name="purchaseType"
                  value={formData.purchaseType || ""}
                  onChange={handleChange}
                  disabled={isView}
                  className="form-control rounded-4"
                ></Input>
              </FormGroup>
            </Col>

            <Col md={3}>
              <FormGroup>
                <Label>Finance Planned</Label>
                <Input
                  name="financePlanned"
                  value={formData.financePlanned || ""}
                  onChange={handleChange}
                  disabled={isView}
                  className="form-control rounded-4"
                ></Input>
              </FormGroup>
            </Col>

            <Col md={3}>
              <FormGroup>
                <Label>File Logined Book</Label>
                <Input
                  name="fileLogin"
                  value={formData.fileLogin || ""}
                  onChange={handleChange}
                  disabled={isView}
                  className="form-control rounded-4"
                ></Input>
              </FormGroup>
            </Col>

            <Col md={3}>
              <FormGroup>
                <Label>Due Date Estimated</Label>
                <Input
                  type="date"
                  name="dueDate"
                  value={formData.dueDate || ""}
                  onChange={handleChange}
                  disabled={isView}
                  className="form-control rounded-4"
                ></Input>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Form>
  )
}

export default LeadForm
